import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "tenant" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = {
  key: 0,
  class: "tenant_name"
}
const _hoisted_4 = { class: "content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_Tabs = _resolveComponent("Tabs")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createTextVNode("Your Tenant ")),
      ($options.tenant_name)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "[" + _toDisplayString($options.tenant_name) + "]", 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_Tabs, {
            modelValue: $options.active,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($options.active) = $event)),
            class: "tabs",
            tabs: $options.tabs,
            bordered: ""
          }, null, 8 /* PROPS */, ["modelValue", "tabs"]),
          _createElementVNode("div", _hoisted_4, [
            ($options.active === 'users')
              ? (_openBlock(), _createBlock($setup["Users"], { key: 0 }))
              : _createCommentVNode("v-if", true),
            ($options.active === 'analytics' && _ctx.tenant)
              ? (_openBlock(), _createBlock($setup["Analytics"], {
                  key: 1,
                  tenant: _ctx.tenant
                }, null, 8 /* PROPS */, ["tenant"]))
              : _createCommentVNode("v-if", true),
            ($options.active === 'settings')
              ? (_openBlock(), _createBlock($setup["Settings"], {
                  key: 2,
                  tenant: _ctx.tenant
                }, null, 8 /* PROPS */, ["tenant"]))
              : _createCommentVNode("v-if", true)
          ])
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}